import { Injectable } from '@angular/core';
import { Geolocation } from '@ionic-native/geolocation/ngx';
import { NativeGeocoder, NativeGeocoderResult, NativeGeocoderOptions } from '@ionic-native/native-geocoder/ngx';

@Injectable()
export class GeocoderService {

    constructor(private geolocation: Geolocation, private nativeGeocoder: NativeGeocoder) {
    }

    getTranslatedGeolocationFromLatLng(latitude, longitude) {
        var self = this;
        let options: NativeGeocoderOptions = {
            useLocale: true,
            maxResults: 5
        };
        return this.nativeGeocoder.reverseGeocode(latitude, longitude, options)
            .then((natgeoResult: NativeGeocoderResult[]) => {
                console.log(JSON.stringify(natgeoResult[0]));
                var firstNatgeo = natgeoResult[0];
                var tempLocality = firstNatgeo["locality"];
                var tempProvince = firstNatgeo["subAdministrativeArea"];
                var tempAddress = firstNatgeo["thoroughfare"];
                if (firstNatgeo["subThoroughfare"] != "") {
                    tempAddress += ", " + firstNatgeo["subThoroughfare"];
                }
                return self.getGeolocationObject(firstNatgeo["latitude"], firstNatgeo["longitude"]
                    , firstNatgeo["countryName"], tempLocality, tempProvince, firstNatgeo["postalCode"], tempAddress
                );
            })
            .catch((error: any) => {
                console.log(error);
                return self.getGeolocationObject(latitude, longitude, "", "", "", "", "");
            });
    }

    getTranslatedGeolocation() {
        var self = this;
        return this.geolocation.getCurrentPosition().then((geoResult) => {
            var latitudine = geoResult["coords"]["latitude"];
            var longitudine = geoResult["coords"]["longitude"];
            console.log(latitudine + " " + longitudine);
            return self.getTranslatedGeolocationFromLatLng(latitudine, longitudine);
        }).catch((error) => {
            console.log('Error getting location', error);
            return null;
        });
    }

    getGeolocationObject(latitudine, longitudine, nazione, citta, provincia, cap, indirizzo) {
        return {
            "latitudine": '' + latitudine,
            "longitudine": '' + longitudine,
            "nazione": nazione,
            "citta": citta,
            "provincia": provincia,
            "cap": cap,
            "indirizzo": indirizzo
        };
    }

}
